// import Vue from 'vue';
// import Vuex from 'vuex';
import routerStatus from './modules/routerStatus';
import userOrMerchant from './modules/userOrMerchant';
import merchantOrder from './modules/merchantOrder';
import userOrder from './modules/userOrder';
// Vue.use(Vuex);


export default new Vuex.Store({
  modules: {
    routerStatus,
    userOrMerchant,
    merchantOrder,
    userOrder
  }
});


// WEBPACK FOOTER //
// ./src/store/index.js